import React, { Component } from 'react'

import '../../App.css';
import '../styles/ServicesMobile.css';

import ContactUsCircle from '../../assets/Contact Us Circle.svg';
import Headset from '../../assets/Headset.svg';
import PinkDiagonal from '../../assets/Pink 1 2.svg';
import YellowStraight from '../../assets/Yellow 2 2.svg';
import PinkCurve from '../../assets/Pink 3 2.svg';
import YellowCircle from '../../assets/Yellow 2.svg';

export default class Services extends Component {

    state = this.props.parentState;

    render() {
        return (
            <div className = "mobile-scrollable-flex-container">

                <div className="goback-container">
                    <div className="goback-button" onClick = {this.props.rightAction}>
                        <img src={ContactUsCircle} className="goback-circle" />
                        Go back
                    </div>
                </div>

                <div className = "headset-mobile-container">
                    <img src = {Headset} className = "headset-mobile"/>
                </div>

                <div className = "services-container">
                    <div className = "line1">
                        {this.props.line1}
                        <div className = "mobile-doodle-container">
                            <img src={PinkDiagonal} className="pink-diagonal"/>
                        </div>
                    </div>

                    <div className="line2">
                        {this.props.line2}
                        <div className="mobile-doodle-container">
                            <img src={YellowStraight} className="yellow-straight" />
                        </div>
                    </div>

                    <div className="line3">
                        {this.props.line3}
                        <div className="mobile-doodle-container">
                            <img src={PinkCurve} className="pink-curve" />
                        </div>
                    </div>

                    <div className="line4">
                        {this.props.line4}
                        <div className="mobile-doodle-container">
                            <img src={YellowCircle} className="yellow-circle" />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
